export const LANDING = '/';
export const LOGIN = '/login';
export const PASSWORD = '/reset-password';
export const SIGNUP = '/signup';
export const CONFIRM = '/confirm';
export const LOADING = '/loading';